import breadboardBasicsLesson from './lessons/breadboardBasics';

const LESSONS = Object.freeze([
  breadboardBasicsLesson,
]);

export const getAllBuilderLessons = () => LESSONS;

export const getBuilderLesson = (lessonId) => (
  LESSONS.find((lesson) => lesson.id === lessonId) || null
);

export const getDefaultBuilderLessonId = () => breadboardBasicsLesson.id;

export const getLessonStorageKey = (lesson) => (
  lesson?.id && lesson?.version
    ? `micropinouts.lesson.${lesson.id}.v${lesson.version}`
    : ''
);

